import { render, staticRenderFns } from "./MyPositionResult.vue?vue&type=template&id=4fbe6cdd&scoped=true&"
import script from "./MyPositionResult.vue?vue&type=script&lang=js&"
export * from "./MyPositionResult.vue?vue&type=script&lang=js&"
import style0 from "./MyPositionResult.vue?vue&type=style&index=0&id=4fbe6cdd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fbe6cdd",
  null
  
)

export default component.exports